"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import { useRouter } from "next/navigation";
import { FaRegBookmark, FaRegCommentDots } from "react-icons/fa";
import { MessageIcon } from "../ui/message-icon";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { getImageUrl, getTimeAgo, getSectionUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
};
export default function VerticalBigImagecategoryNewsbgWhite(t0) {
  const $ = _c(49);
  const {
    category: t1,
    sectionUrl,
    title: t2,
    excerpt: t3,
    timeAgo: t4,
    imageSrc: t5,
    slug,
    imageMetadata
  } = t0;
  const category = t1 === undefined ? {
    hidden: false,
    value: "TAMIL NADU",
    customClass: ""
  } : t1;
  let t6;
  if ($[0] !== t2) {
    t6 = t2 === undefined ? {
      hidden: false,
      value: "\u0BB9\u0BA9\u0BBF \u0B9F\u0BCD\u0BB0\u0BBE\u0BAA\u0BCD\u0BAA\u0BBF\u0B99\u0BCD: \u0BA8\u0BB5\u0BBF \u0BAE\u0BC1\u0BAE\u0BCD\u0BAA\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B87\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 7 \u0BAA\u0BC7\u0BB0\u0BCD \u0B95\u0BCA\u0BA3\u0BCD\u0B9F \u0B95\u0BC1\u0BAE\u0BCD\u0BAA\u0BB2\u0BC8 \u0B95\u0BCB\u0BB5\u0BC8 \u0B9A\u0BC8\u0BAA\u0BB0\u0BCD \u0B95\u0BBF\u0BB0\u0BC8\u0BAE\u0BCD \u0BAA\u0BCB\u0BB2\u0BC0\u0B9A\u0BBE\u0BB0\u0BCD \u0B95\u0BC8\u0BA4\u0BC1 \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BA9\u0BB0\u0BCD",
      customClass: ""
    } : t2;
    $[0] = t2;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const title = t6;
  let t7;
  if ($[2] !== t3) {
    t7 = t3 === undefined ? {
      hidden: false,
      value: "\u0B85\u0BB5\u0BB0\u0BCD\u0B95\u0BB3\u0BCD \u0B85\u0BAA\u0BCD\u0B9A\u0BB2\u0BCD \u0BB0\u0B9A\u0BC2\u0BB2\u0BCD\u0BAE\u0BBE\u0BA9\u0BBE\u0BB2\u0BCD \u0BAA\u0BA3\u0BBF\u0BAF\u0BAE\u0BB0\u0BCD\u0BA4\u0BCD\u0BA4\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA9\u0BB0\u0BCD \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0BA8\u0BB5\u0BBF \u0BAE\u0BC1\u0BAE\u0BCD\u0BAA\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B89\u0BB3\u0BCD\u0BB3 \u0B89\u0BB2\u0BCD\u0BB5\u0BC7, \u0B9A\u0BC6\u0B95\u0BCD\u0B9F\u0BB0\u0BCD 19 \u0B87\u0BB2\u0BCD \u0B89\u0BB3\u0BCD\u0BB3 \u0B92\u0BB0\u0BC1 \u0B85\u0B9F\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BBE\u0B9F\u0BBF \u0B95\u0BC1\u0B9F\u0BBF\u0BAF\u0BBF\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD \u0B87\u0BAF\u0B99\u0BCD\u0B95\u0BBF \u0BB5\u0BA8\u0BCD\u0BA4\u0BA9\u0BB0\u0BCD.",
      customClass: ""
    } : t3;
    $[2] = t3;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const excerpt = t7;
  let t8;
  if ($[4] !== t4) {
    t8 = t4 === undefined ? {
      hidden: false,
      value: "15 min ago",
      customClass: ""
    } : t4;
    $[4] = t4;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const timeAgo = t8;
  let t9;
  if ($[6] !== t5) {
    t9 = t5 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t5;
    $[6] = t5;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const imageSrc = t9;
  useRouter();
  category?.value || "";
  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  const t10 = timeAgo?.value;
  let t11;
  if ($[8] !== t10) {
    t11 = getTimeAgo(t10);
    $[8] = t10;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const timeAgoValue = t11;
  let t12;
  if ($[10] !== imageSrc?.value) {
    t12 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[10] = imageSrc?.value;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const imageSrcValue = t12;
  getSectionUrl(sectionUrl);
  let t13;
  if ($[12] !== imageMetadata || $[13] !== imageSrc?.customClass || $[14] !== imageSrc?.hidden || $[15] !== imageSrcValue || $[16] !== titleValue) {
    t13 = !imageSrc?.hidden && <div className={` ${imageSrc?.customClass || ""}`}><div className="relative w-full aspect-[16/9] md:aspect-[16/7] overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 400px" className="object-cover w-full h-full" style={getFocusPointStyle(imageMetadata)} loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[12] = imageMetadata;
    $[13] = imageSrc?.customClass;
    $[14] = imageSrc?.hidden;
    $[15] = imageSrcValue;
    $[16] = titleValue;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== title?.customClass || $[19] !== title?.hidden || $[20] !== titleValue) {
    t14 = !title?.hidden && <h3 className={`text-FFFFFF text-24-tamil-700 md:text-16-tamil-700 leading-[1.4] min-h-[67px] ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[18] = title?.customClass;
    $[19] = title?.hidden;
    $[20] = titleValue;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== excerpt?.customClass || $[23] !== excerpt?.hidden || $[24] !== excerptValue) {
    t15 = !excerpt?.hidden && <p className={`text-14-tamil-400 md:text-14-tamil-400 text-FFFFFF leading-[1.5] line-clamp-2 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[22] = excerpt?.customClass;
    $[23] = excerpt?.hidden;
    $[24] = excerptValue;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== timeAgo?.customClass || $[27] !== timeAgo?.hidden || $[28] !== timeAgoValue) {
    t16 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-FFFFFF ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[26] = timeAgo?.customClass;
    $[27] = timeAgo?.hidden;
    $[28] = timeAgoValue;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const t17 = slug ? `/${slug}` : undefined;
  let t18;
  if ($[30] !== excerptValue || $[31] !== imageSrcValue || $[32] !== slug || $[33] !== t17 || $[34] !== titleValue) {
    t18 = <div className="flex items-center gap-4"><MessageIcon id="small-image-news-vert-message-icon" variant="message-icon-4" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t17} /></div>;
    $[30] = excerptValue;
    $[31] = imageSrcValue;
    $[32] = slug;
    $[33] = t17;
    $[34] = titleValue;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t16 || $[37] !== t18) {
    t19 = <div className="flex items-center justify-between gap-2">{t16}{t18}</div>;
    $[36] = t16;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t14 || $[40] !== t15 || $[41] !== t19) {
    t20 = <div className="flex flex-col gap-2">{t14}{t15}{t19}</div>;
    $[39] = t14;
    $[40] = t15;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t13 || $[44] !== t20) {
    t21 = <article className="flex flex-col bg-transparent overflow-hidden p-4 gap-4">{t13}{t20}</article>;
    $[43] = t13;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  const content = t21;
  if (slug) {
    const t22 = `/${slug}`;
    let t23;
    if ($[46] !== content || $[47] !== t22) {
      t23 = <Link href={t22} className="block transition-opacity cursor-pointer">{content}</Link>;
      $[46] = content;
      $[47] = t22;
      $[48] = t23;
    } else {
      t23 = $[48];
    }
    return t23;
  }
  return content;
}